/* eslint-disable sonarjs/no-duplicate-string */

const getFieldAnalytics = (block: string) => ({
    focus: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ввод данных',
    },
    correct: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Успешный ввод',
    },
    incorrect: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ошибка',
    },
});

export const firstStepAnalytics = {
    view: {
        block: 'Анкета Новая форма',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Шаг 1',
    },
    lastName: getFieldAnalytics('Анкета Новая форма - Фамилия'),
    firstName: getFieldAnalytics('Анкета Новая форма - Имя'),
    middleName: getFieldAnalytics('Анкета Новая форма - Отчество'),
    passportBirthDate: getFieldAnalytics('Анкета Новая форма - Дата рождения'),
    email: {
        view: {
            block: 'Анкета Новая форма - Электронная почта',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Электронная почта',
        },
        ...getFieldAnalytics('Анкета Новая форма - Электронная почта'),
    },

    phone: {
        view: {
            block: 'Анкета Новая форма - Мобильный телефон',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Мобильный телефон',
        },
        ...getFieldAnalytics('Анкета Новая форма - Мобильный телефон'),
    },
    submit: {
        fail: {
            block: 'Анкета - Шаг 1',
            event: 'gtm_interaction_event',
            action: 'Send',
            label_detail: 'Ошибка отправки формы',
        },
        success: {
            block: 'Анкета - Шаг 1',
            event: 'gtm_interaction_event',
            action: 'Send',
            label_detail: 'Успешная отправка формы',
        },
    },
    fullName: {
        view: {
            block: 'Анкета Новая форма - ФИО',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'ФИО в одно поле',
        },
        expandToThreeFields: {
            block: 'Анкета Новая форма - ФИО в три поля',
            event: 'gtm_non_interaction_event',
            action: 'View',
        },
        ...getFieldAnalytics('Анкета Новая форма - ФИО'),
    },

    hasMiddleName: {
        click: {
            block: 'Анкета Новая форма - По паспорту без отчества',
            event: 'gtm_interaction_event',
            action: 'Choice',
            label_detail: 'Чекбокс - По паспорту без отчества',
        },
    },
    sex: {
        click: {
            block: 'Анкета Новая форма - Пол',
            event: 'gtm_interaction_event',
            action: 'Choice',
        },
        view: {
            block: 'Анкета Новая форма - Пол',
            event: 'gtm_interaction_event',
            action: 'View',
            label_detail: 'Выбор пола',
        },
    },
    isClient: {
        view: {
            block: 'Анкета Новая форма - Клиент Альфа-Банка',
            event: 'gtm_non_interaction_event',
            action: 'View',
        },
        click: {
            block: 'Анкета Новая форма - Клиент Альфа-Банка',
            event: 'gtm_interaction_event',
            action: 'Choice',
        },
    },
    resident: {
        block: 'Анкета Новая форма - Гражданство РФ',
        event: 'gtm_interaction_event',
        action: 'Choice',
    },
    residentView: {
        block: 'Анкета Новая форма - Гражданство РФ',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Да',
    },
};

export const passportStepAnalytics = {
    view: {
        block: 'Кажется мы уже знакомы',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Серия и номер паспорта',
    },
    passport: getFieldAnalytics('Серия и номер паспорта'),
    submit: {
        block: 'Серия и номер паспорта',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Проверить',
    },
};

export const changePhoneNumberStepAnalytics = {
    view: {
        block: 'Анкета Новая форма - Введите новый номер',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Введите новый номер',
    },
    ...getFieldAnalytics('Анкета Новая форма - Введите новый номер'),
    change: {
        block: 'Анкета Новая форма - Введите новый номер',
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ввод данных',
    },
    cancel: {
        block: 'Анкета Новая форма - Введите новый номер',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Отменить',
    },
    submit: {
        block: 'Анкета Новая форма - Введите новый номер',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Изменить',
    },
};

export const smsStepAnalytics = {
    view: {
        block: 'Pop-up с СМС кодом',
        event: 'gtm_non_interaction_event',
        action: 'View',
        ymEvent: [
            {
                method: 'reachGoal',
                params: 'dc_send_step1',
            },
        ],
        label_detail: 'Введите СМС код формы',
    },
    change: {
        block: 'Pop-up с СМС кодом',
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ввод данных',
    },
    fail: {
        view: {
            block: 'Pop-up с СМС кодом - Ввести код больше нельзя',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Ввести код больше нельзя',
        },
        click: {
            block: 'Pop-up с СМС кодом - Ввести код больше нельзя',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Понятно',
        },
    },
    resendButton: {
        view: {
            block: 'Pop-up с СМС кодом - Запросить код повторно',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Запросить код повторно',
        },
        click: {
            block: 'Pop-up с СМС кодом - Запросить код повторно',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Запросить код повторно',
        },
    },
    changePhoneButton: {
        view: {
            block: 'Pop-up с СМС кодом - Изменить номер телефона',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Изменить номер телефона',
        },
        click: {
            block: 'Pop-up с СМС кодом - Изменить номер телефона',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Изменить номер телефона',
        },
    },
    submit: {
        fail: {
            block: 'Pop-up с СМС кодом',
            event: 'gtm_interaction_event',
            action: 'Enter',
            label_detail: 'Неверный код',
        },
        success: {
            block: 'Pop-up с СМС кодом ',
            event: 'gtm_interaction_event',
            action: 'Enter',
            label_detail: 'Успешный ввод',
        },
    },
};

export const verifySmsStepAnalytics = {
    view: {
        block: 'Заказ доставки - подтверждение СМС',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Введите код из сообщения',
    },
    change: {
        block: 'Заказ доставки - подтверждение СМС',
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ввод данных',
    },
    fail: {
        view: {
            block: 'Заказ доставки - подтверждение СМС - Ввести код больше нельзя',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Ввести код больше нельзя',
        },
        click: {
            block: 'Заказ доставки - подтверждение СМС - Ввести код больше нельзя',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Понятно',
        },
    },
    resendButton: {
        view: {
            block: 'Заказ доставки - подтверждение СМС - Запросить код повторно',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Запросить код повторно',
        },
        click: {
            block: 'Заказ доставки - подтверждение СМС - Запросить код повторно',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Запросить код повторно',
        },
    },
    changePhoneButton: {
        view: {
            block: 'Заказ доставки - подтверждение СМС - Изменить номер телефона',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Изменить номер телефона',
        },
        click: {
            block: 'Заказ доставки - подтверждение СМС - Изменить номер телефона',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: 'Изменить номер телефона',
        },
    },
    submit: {
        fail: {
            block: 'Заказ доставки - подтверждение СМС',
            event: 'gtm_interaction_event',
            action: 'Enter',
            label_detail: 'Неверный код',
        },
        success: {
            block: 'Заказ доставки - подтверждение СМС ',
            event: 'gtm_interaction_event',
            action: 'Enter',
            label_detail: 'Успешный ввод',
        },
    },
};

export const errorStepAnalytics = {
    GONE: {
        block: 'Экран ошибки: Заявка устарела',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Gone',
    },
    CONFLICT: {
        block: 'Экран ошибки: слот не доступен',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Conflict',
    },
    NO_OFFER: {
        block: 'Экран ошибки: частичный отказ, приглашение в офис',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'No offer',
    },
    DT_CLIENT: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Dt client',
    },
    NOT_FOUND: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
    BAD_GATEWAY: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
    CLIENT_ERROR: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
    UNAUTHORIZED: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
    REFER_TO_OFFICE: {
        block: 'Экран ошибки - приглашение в офис',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Refer to office',
    },
    SESSION_EXPIRED: {
        block: 'Экран ошибки: Время текущей сессии истекло',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Session expiered',
    },
    VALIDATION_ERROR: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
    REJECT_COMPLETELY: {
        block: 'Экран ошибки: клиент из черного списка',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Reject completely',
    },
    TOO_MANY_REQUESTS: {
        block: 'Экран ошибки: превышено количество запросов кода',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Too many requests',
    },
    INTERNAL_SERVER_ERROR: {
        block: 'Экран ошибки: что-то пошло не так',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Internal server error',
    },
};

export const draftStepAnalytics = {
    view: {
        block: 'Анкета Новая форма - Черновик',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Черновик',
    },
    disagree: {
        block: 'Анкета Новая форма - Черновик',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Заполнить новую заявку',
    },
    agree: {
        block: 'Анкета Новая форма - Черновик',
        event: 'gtm_interaction_event',
        action: 'Click',
        label_detail: 'Продолжить заполнение',
    },
};
